import {ACTION_TYPES, COMPONENT_STATES} from "../consts";
import {PopulateDataHandler} from "../../infrastructure/handlers/populate-data-handler";
import {ModuleController} from "../../infrastructure/controllers/module-controller";

export class FullGamePopulateDataHandler extends PopulateDataHandler {
  type = ACTION_TYPES.populateData;

  onInitialized(controller: ModuleController) {
    super.onInitialized(controller);

    if(controller.props.location?.state?.dataSource){
      this.action(controller.props.location.state);
    }
  }

  async action(params) {
    if(params?.dataSource?.game || params?.dataSource?.tabIndex || params?.dataSource?.isHomeTeamSelected) {
      this.state.dataSource = params.dataSource;

      this.store.setComponentState(COMPONENT_STATES.loaded);
    }
  }
}
